const creditTypes = {
  SET_CREDIT_TAB: "SET_CREDIT_TAB",

  FETCH_ACCOUNTDEATAIL_START: "FETCH_ACCOUNTDEATAIL_START",
  FETCH_ACCOUNTDEATAIL_SUCCESS: "FETCH_ACCOUNTDEATAIL_SUCCESS",

  FETCH_WITHDRAWALS_START: "FETCH_WITHDRAWALS_START",
  FETCH_WITHDRAWALS_SUCCESS: "FETCH_WITHDRAWALS_SUCCESS",
};

export default creditTypes;
